export const EXECUTION_TABLE = "executions"
export const EXECUTION_TABLE_SCHEMA = "id, agentType, status, createdAt, syncId"
